module.exports = __webpack_public_path__ + "img/norway-pregnancy-childbirth-and-the-puerperium-female.f57fe7c8.png";